import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import { Card, Form, Button, Row, Col, Table, Badge } from "react-bootstrap";
import { FaSearch, FaEraser, FaEye } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, statusEmailBadge, areasEmailLog } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';

class HistoricoEmail extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscarLogs = this.buscarLogs.bind(this);
        this.carregaProgramasDelay = this.delayCamposAsync(this.carregarProgramas.bind(this), 800);

        this.state = {
            listRegistros: [],
            error: "",
            filtro_data_inicio: "",
            filtro_data_fim: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            filtro_area: "",
            page_numb: 1,
            loading: true,
            programasOptions: [],
            loadingProgramas: false,
        };
    }

    componentDidMount() {
        this.consultaLogs(1);
    }

    delayCamposAsync = (fn, delay = 800) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
                timeout = setTimeout(async () => {
                    try {
                        const res = await fn(...args);
                        resolve(res);
                    } catch (e) {
                        resolve([]);
                    }
                }, delay);
            });
        };
    };

    carregarProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {
                this.setState({ loadingProgramas: true });
            }

            const response = await api.get(`/programas/?nome=${encodeURIComponent(inputValue)}`);
            const opcoes = (response.data?.results || []).map((programa) => ({
                value: programa.id,
                label: programa.nome
            }));

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false,
                });
            }

            return opcoes;
        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {
                this.setState({ loadingProgramas: false });
            }
            return [];
        }
    };

    consultaLogs = (page_numb = 1) => {
        this.setState({ loading: true, error: "" });

        const params = new URLSearchParams();
        params.append('page', page_numb);

        if (this.state.filtro_data_inicio) {
            params.append('data_inicio', this.state.filtro_data_inicio);
        }

        if (this.state.filtro_data_fim) {
            params.append('data_fim', this.state.filtro_data_fim);
        }

        if (this.state.filtro_programa_id) {
            params.append('programa_id', this.state.filtro_programa_id);
        }

        if (this.state.filtro_area) {
            params.append('area', this.state.filtro_area);
        }

        params.append('latest_only', 'true');

        api.get(`/atendimentos/email-send-logs/?${params.toString()}`)
            .then((response) => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb,
                });
            })
            .catch((error) => {
                let erro_msg = 'Erro ao consultar histórico de emails, tente novamente.';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                } else if (error.response && error.response.data?.detail) {
                    erro_msg = String(error.response.data.detail);
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            this.setState({
                filtro_programa_id: event?.value || "",
                filtro_programa_nome: event?.label || "",
            });
            return;
        }

        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.consultaLogs(num_page);
    }

    buscarLogs(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });

        this.consultaLogs(1);
    }

    limpaFiltro = () => {
        this.setState({
            filtro_data_inicio: "",
            filtro_data_fim: "",
            filtro_programa_id: "",
            filtro_programa_nome: "",
            filtro_area: "",
        }, () => {
            this.consultaLogs(1);
        });
    };

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item) => (
                <tr key={item.id}>
                    <td>{item.send_date ? formataDataHoraExibicao(item.send_date) : '-'}</td>
                    <td>{item?.dados_programa?.nome || '-'}</td>
                    <td>{item.area || '-'}</td>
                    <td>{item.send_email || '-'}</td>
                    <td>
                        <div>
                            {item.status ? (
                                (() => {
                                    const badge = statusEmailBadge(item.status);
                                    return <Badge bg={badge.bg} text={badge.text}>{item.status}</Badge>;
                                })()
                            ) : '-'}
                        </div>
                        {item.bounce_reason && (
                            <div
                                className="text-danger small text-truncate"
                                style={{ maxWidth: '220px' }}
                                title={item.bounce_reason}
                            >
                                {item.bounce_reason}
                            </div>
                        )}
                    </td>
                    <td className="text-end">
                        <Button
                            variant="light"
                            size="sm"
                            onClick={() => Swal.fire({
                                title: 'Detalhes do envio',
                                html: `
                                    <div class="text-start">
                                        <p><strong>Data/Hora:</strong> ${item.send_date ? formataDataHoraExibicao(item.send_date) : '-'}</p>
                                        <p><strong>Programa:</strong> ${item?.dados_programa?.nome || '-'}</p>
                                        <p><strong>Área:</strong> ${item.area || '-'}</p>
                                        <p><strong>Destinatário:</strong> ${item.send_email || '-'}</p>
                                        <p><strong>Status:</strong> ${item.status || '-'}</p>
                                        <p><strong>Evento:</strong> ${item.event_type || '-'}</p>
                                        <p><strong>ID SES:</strong> ${item.id_ses || '-'}</p>
                                        <p><strong>Atendimento:</strong> ${item.atendimento_id || '-'}</p>
                                        <p><strong>Relato:</strong> ${item.relato_id || '-'}</p>
                                        <p><strong>Data confirmação:</strong> ${item.confirmation_date ? formataDataHoraExibicao(item.confirmation_date) : '-'}</p>
                                        <p><strong>Motivo bounce:</strong> ${item.bounce_reason || '-'}</p>
                                    </div>
                                `,
                                width: 700,
                                confirmButtonText: 'Fechar'
                            })}
                        >
                            <FaEye /> Detalhes
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={6}>Nenhum histórico de email encontrado</td>
            </tr>
        );
    };

    render() {
        if (!hasPerm('view_logs')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Histórico de Emails</h4>
                    </Col>
                </Row>

                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscarLogs}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregaProgramasDelay}
                                            defaultOptions
                                            isClearable
                                            name="programa_id"
                                            placeholder="Todos os programas"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={(e) => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_area"
                                            value={this.state.filtro_area}
                                            onChange={(e) => this.handleChangeFiltros(e)}
                                        >
                                            <option value="">Todas as áreas</option>
                                            {Object.entries(areasEmailLog).map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_inicio"
                                            value={this.state.filtro_data_inicio}
                                            onChange={(e) => this.handleChangeFiltros(e)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Fim</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_fim"
                                            value={this.state.filtro_data_fim}
                                            onChange={(e) => this.handleChangeFiltros(e)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-between">
                                <Button type="submit" variant="secondary" size="sm">
                                    <FaSearch /> Filtrar
                                </Button>
                                <Button type="button" size="sm" variant="light" className="ms-2" onClick={this.limpaFiltro}>
                                    <FaEraser /> Limpar filtro
                                </Button>
                            </div>
                        </Form>

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Programa</th>
                                    <th>Área</th>
                                    <th>Destinatário</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan={6}>Carregando...</td>
                                    </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={6}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        <Paginacao
                            dados={this.state.listRegistros}
                            _onClickPagina={this.onClickPagina}
                            page_numb={this.state.page_numb}
                            loading={this.state.loading}
                        />
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(HistoricoEmail);
